import { render, staticRenderFns } from "./EditorMenu.vue?vue&type=template&id=5cb28b76&scoped=true&"
import script from "./EditorMenu.vue?vue&type=script&lang=ts&"
export * from "./EditorMenu.vue?vue&type=script&lang=ts&"
import style0 from "./EditorMenu.vue?vue&type=style&index=0&id=5cb28b76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb28b76",
  null
  
)

export default component.exports